import { VStack } from "@chakra-ui/react"
import React from "react"
import { AddIBeaconToZoneForm } from "../../forms"
import { ExtendedZoneFragment } from "../../graphql"

export type AddIBeaconToZoneProps = {
	zone: ExtendedZoneFragment
}

export const AddIBeaconToZone: React.FC<AddIBeaconToZoneProps> = ({ zone }) => {
	return (
		<VStack w="full" spacing={6} maxW="sm">
			<AddIBeaconToZoneForm zoneId={zone._id} />
		</VStack>
	)
}
